import {serviceUrlPortalSystem} from "../services/SystemResource";

const DEFAULT_MEDIA_DOWNLOAD_PATH = serviceUrlPortalSystem + "/media/download/";
const CACHED_FOR = 1000*60*60*24*100;

export function getMediaPath(mediaName: string) {
    return (process.env.REACT_APP_MEDIA_DOWNLOAD_PATH || DEFAULT_MEDIA_DOWNLOAD_PATH) + mediaName + "?cachedFor=" + CACHED_FOR;
}
